import FaceDetectionWorkerFactory from './faceDetectionWorker/faceDetectionWorkerFactory';
import MaskDetectionWorkerFactory from './maskDetectionWorker/maskDetectionWorkerFactory';
import TemperatureDetectionWorkerFactory from './temperatureDetectionWorker/temperatureDetectionWorkerFactory';

const workers = {
  FaceDetectionWorkerFactory,
  MaskDetectionWorkerFactory,
  TemperatureDetectionWorkerFactory,
};

export default workers;
